import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface OrderDateStyles {
    wrapper?: GridItemProps;
    titleText?: TypographyProps;
    orderDate?: TypographyProps;
}

export const orderDateStyles: OrderDateStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 16px;
        `,
    },
};


const styles = orderDateStyles;

const OrderWebOrderNumber: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.erpOrderNumber) {
        return null;
    }

    return (
        <>
        <GridItem {...styles.wrapper}>    
     <Typography {...styles.orderDate} aria-labelledby="orderNumber" data-test-selector="orderNumber">                
    <strong> {translate("Order Number")}</strong>: {order.erpOrderNumber}
     </Typography>            
 </GridItem>     
        </>
    );
};

const widgetModule: WidgetModule = {
    component: OrderWebOrderNumber,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
